"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectBlindAction = exports.StudySubjectBlindActionType = void 0;
var StudySubjectBlindActionType;
(function (StudySubjectBlindActionType) {
    StudySubjectBlindActionType["UnblindRequest"] = "UNBLIND_REQUEST";
    StudySubjectBlindActionType["UnblindApprove"] = "UNBLIND_APPROVE";
    StudySubjectBlindActionType["UnblindForce"] = "UNBLIND_FORCE";
    StudySubjectBlindActionType["UnblindForceUnderConds"] = "UNBLIND_FORCE_UNDER_CONDITIONS";
})(StudySubjectBlindActionType = exports.StudySubjectBlindActionType || (exports.StudySubjectBlindActionType = {}));
class StudySubjectBlindAction {
}
exports.StudySubjectBlindAction = StudySubjectBlindAction;
//# sourceMappingURL=studySubjectBlindAction.js.map